function _slicedToArray(arr, i) {return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();}function _nonIterableRest() {throw new TypeError("Invalid attempt to destructure non-iterable instance");}function _iterableToArrayLimit(arr, i) {var _arr = [];var _n = true;var _d = false;var _e = undefined;try {for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {_arr.push(_s.value);if (i && _arr.length === i) break;}} catch (err) {_d = true;_e = err;} finally {try {if (!_n && _i["return"] != null) _i["return"]();} finally {if (_d) throw _e;}}return _arr;}function _arrayWithHoles(arr) {if (Array.isArray(arr)) return arr;}function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _defineProperties(target, props) {for (var i = 0; i < props.length; i++) {var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);}}function _createClass(Constructor, protoProps, staticProps) {if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;}var STACK = {/*[name]:[RouterAction]*/};
var defaultStackName = '_default_';var

RouterAction = /*#__PURE__*/function () {_createClass(RouterAction, [{ key: "defaults", get: function get()
    {return {
        url: '' };
    } }]);

  function RouterAction(data) {_classCallCheck(this, RouterAction);
    Object.assign(this, this.defaults, data);
  }return RouterAction;}();



export var NavigationStack = /*#__PURE__*/function () {NavigationStack.$inject = ["$location"];
  function NavigationStack($location) {
    "ngInject";_classCallCheck(this, NavigationStack);
    this.$location = $location;
  }_createClass(NavigationStack, [{ key: "push", value: function push()

    {for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {args[_key] = arguments[_key];}var _normalise =
      normalise(args),_normalise2 = _slicedToArray(_normalise, 2),name = _normalise2[0],action = _normalise2[1];
      console.log('[NavigationStack] push', name, action);
      var newAction = new RouterAction(action);
      (STACK[name] || (STACK[name] = [])).push(newAction);
      console.warn('startAction', newAction);
      return newAction;
    } }, { key: "pop", value: function pop()

    {for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {args[_key2] = arguments[_key2];}var _normalise3 =
      normalise(args),_normalise4 = _slicedToArray(_normalise3, 2),name = _normalise4[0],defaultAction = _normalise4[1];
      var action = (STACK[name] || []).pop() || new RouterAction(defaultAction);
      this.completeAction(action);
      return action;
    } }, { key: "close", value: function close()

    {for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {args[_key3] = arguments[_key3];}var _normalise5 =
      normalise(args),_normalise6 = _slicedToArray(_normalise5, 2),name = _normalise6[0],defaultAction = _normalise6[1];var _ref =
      STACK[name] || [],_ref2 = _slicedToArray(_ref, 1),_ref2$ = _ref2[0],action = _ref2$ === void 0 ? new RouterAction(defaultAction) : _ref2$;
      STACK[name] = [];
      this.completeAction(action);
      return action;
    } }, { key: "completeAction", value: function completeAction(

    action) {
      console.warn('completeAction', action);
      this.$location.url(action.url);
    } }]);return NavigationStack;}();




function normalise(args) {
  switch (args.length) {
    case 0:return [defaultStackName];
    case 1:return [defaultStackName, args[0]];
    default:return args;}

}